<template>
    <v-card-text v-if="user && userBalanceInfo !== undefined && Object.keys(userBalanceInfo).length" class="py-2">
        <v-container class="font14 pl-3 pr-0">
            <v-row>
                <v-col cols="4" class="px-2 pt-0 pb-0 user-balance">
                    {{ $t('menu.credit') }}
                    <br />
                    <span :class="[$vuetify.breakpoint.xs ? 'lh-1-1' : '', $vuetify.theme.dark ? 'whiteText' : 'blackText', 'bold']">
                        {{ utils.getCurrencySymbol(user.currency) }}{{ utils.formatNumber(userBalanceInfo.credit, 'money') }}
                    </span>
                </v-col>
                <v-col cols="4" class="px-2 pt-0 pb-0 user-balance">
                    {{ $t('menu.balance') }}
                    <br />
                    <span :class="[userBalanceInfo.balance < 0 ? 'redText' : 'greenText', 'bold']">
                        {{ utils.getCurrencySymbol(user.currency) }}{{ utils.formatNumber(userBalanceInfo.balance, 'money') }}
                    </span>
                </v-col>
                <v-col cols="4" class="px-2 pt-0 pb-0 user-balance">
                    {{ $t('menu.exposure') }}
                    <br />
                    <span class="orangeText bold">{{ utils.getCurrencySymbol(user.currency) }}{{ utils.formatNumber(userBalanceInfo.exposure, 'money') }}</span>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>
<style scoped></style>
<script>
    export default {
        name: 'app-menuAccountBalanceInfo',
        components: {},
        data() {
            return {};
        },

        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {},

        computed: {
            userBalanceInfo: {
                get() {
                    return this.$store.getters['UserModule/getBalance'];
                },
            },

            user() {
                return this.$store.getters['UserModule/getUser'];
            },
        },
    };
</script>
